import axiosInstance from "../../lib/axios";

//  STEP ONE API FUNCTIONS
export async function createPropertyDetails(payload) {
  try {
    const response = await axiosInstance.post(
      `PropertyMst/InsertPropertyMst`,
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function updatePropertyDetails(payload) {
  try {
    const response = await axiosInstance.post(
      `PropertyMst/UpdatePropertyMst`,
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function getRoomMasterdropdata(payload) {
  try {
    const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`, payload);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getUserWisePropertydata(payload) {
  try {
    const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`, payload);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getShiftMasterdropdata(payload) {
  try {
    const response = await axiosInstance.post(`Shift/GetShiftDrp`, payload);
    return response;
  } catch (error) {
    return error;
  }
}
export async function getYojnaMasterdropdata(payload) {
  try {
    const response = await axiosInstance.post(`MstYojana/GetdrpMstYojana`, payload);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getYojnaMastearedrp(payload) {
  try {
    const response = await axiosInstance.post(`MstHkWrkArea/getMstHkWrkAreadrp`, payload);
    return response;
  } catch (error) {
    return error;
  }
}


export async function updatebedcalender(payload) {
  try {
    const response = await axiosInstance.post(`BedCalendar/MangeBedCalendarConfig`, payload);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getPropertyDetails(propid, flag = "N") {
  try {
    return await axiosInstance.post("/PropertyMst/RetrivePropertyMst", {
      PropId: propid,
      Flag: flag,
    });
  } catch (error) {
    return error;
  }
}

// STEP TWO API FUNCTIONS
export async function getWingsFloors(payload) {
  try {
    return await axiosInstance.post(
      "/MstPropFloorConfig/GetMstPropFloorConfigDashBoard",
      payload
    );
  } catch (err) {
    return err;
  }
}

export async function getMstPropRoomConfigDashBoard(PropId) {
  try {
    return await axiosInstance.post(
      "MstPropFloorConfig/GetMstPropRoomConfigDashBoard",
      { PropId: PropId }
    );
  } catch (error) {
    return error;
  }
}

// STEP THREE API FUNCTIONS
export async function getAmenities(payload) {
  try {
    return await axiosInstance.post(
      "/MstPropFloorConfig/GetMstPropAmenityConfigDashBoard",
      payload
    );
  } catch (err) {
    return err;
  }
}

// Get area by pincode
export const getAreaByPin = async (Pincode) => {
  try {
    const { data } = await axiosInstance.post(
      `pincodeMst/getdrppincodewisearea`,
      {
        pinCode: parseInt(Pincode),
      }
    );
    if (data.Status === 0 && data.responseStatusCode === 1) {
      return data.Data;
    }
  } catch (error) {
    console.error("Error fetching Area:", error);
  }
};

// DELETE ALL FUNCTIONS
export const deleteRecordByPropId = async (propId) => {
  try {
    await Promise.all([
      deleteWingByPropId({
        PropId: propId,
        WingId: 0,
        FloorId: 0,
      }),
      deleteAmenities(propId),
    ]);

    const response = await deletePropertyDetails(propId);
    return response;
  } catch (err) {
    return err;
  }
};

export async function deletePropertyDetails(propid) {
  try {
    return await axiosInstance.post("/PropertyMst/RetrivePropertyMst", {
      PropId: propid,
      Flag: "D",
    });
  } catch (err) {
    return err;
  }
}

export async function deleteWingByPropId(payload) {
  try {
    return await axiosInstance.post(
      "/MstPropFloorConfig/DeleteMstPropFloorConfig",
      payload
    );
  } catch (err) {
    return err;
  }
}

export async function deleteRoomMst(payload) {
  try {
    return await axiosInstance.post("RoomMst/ManageRoomUpdation", payload);

  }
  catch (error) {
    return error;
  }
}

export async function GetBedCalendarMonthwise(payload) {
  try {
    return await axiosInstance.post("BedCalendar/GetBedCalendarMonthwise", payload);

  }
  catch (error) {
    return error;
  }
}

export async function GenerateBedCatCal(payload) {
  try {
    return await axiosInstance.post("BedCalendar/GenerateBedCatCal", payload);
  }
  catch (error) {
    return error;
  }
}

export async function GetPropWiseBedCalendarMonth(payload) {
  try {
    const params = new URLSearchParams();
    params.append('currentPage', payload.currentPage || 1);
    params.append('limit', payload.PageSize || 180);

    const response = await axiosInstance.post(
      `BedCalendar/GetPropWiseBedCalendarMonth?${params.toString()}`,
      payload
    );

    console.log('API Call:', {
      url: `BedCalendar/GetPropWiseBedCalendarMonth?${params.toString()}`,
      payload: payload,
      response: response.data
    });

    return response;
  } catch (error) {
    console.error('API Error:', error);
    return error;
  }
}

export async function deleteAmenities(propid, amenityId) {
  try {
    let payload = { PropId: propid };
    if (amenityId) {
      payload.AmenityId = amenityId;
    }
    return await axiosInstance.post(
      "/MstPropFloorConfig/DeleteMstPropAmenityConfig",
      payload
    );
  } catch (err) {
    return err;
  }
}

//Lock Property
// export async function getLockData(payload) {
//   try {
//     return await axiosInstance.post("Lock/GetLockData", payload);
//   } catch (err) {
//     return err;
//   }
// }

// export async function updateLock(payload){
//   try{
//     return await axiosInstance.post('Lock/UpdateLock',payload);
//   }catch(err){
//     return err;
//   }
// }

